import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../translate';
import ShopPriceEstimation from '../../../sections/shop/shopItems/ShopPriceEstimation';
import CheckoutTerms from '../../../sections/shop/components/CheckoutTerms';
import TenantProp from '../../propTypes/tenantProp';

const AcademySideBar =
  ({
     t,
     checkoutDetail,
     onClearCoupon,
     onChangeNotes,
     createOrder,
     onClose,
     isDisabled,
     orderAlreadyCreated,
     tenant,
     checkedTerms,
     isDirectSellingActive,
     onChangeTerms,
     step,
     onChangeStep,
   }) => (
    <>
      <div className="academy-order-detail">
        <button type="button" className="close close-checkout-modal hide-inSmall" onClick={onClose}>
          <span aria-hidden="true">×</span>
        </button>
        <ShopPriceEstimation
          t={t}
          orderDetails={checkoutDetail}
          onClearCoupon={onClearCoupon}
          showClearCoupon
          isPaidWithCoins={checkoutDetail.isPaidWithCoins}
          directSellingActive={isDirectSellingActive}
        />
        {step === 3 && (
          <div className="notes-card">
            <h3>
              {t('shop.cart.notes')}
            </h3>
            <textarea
              className="form-control notes-input"
              placeholder={t('shop.cart.notes.placeholder')}
              onChange={onChangeNotes}
              rows={5}
              disabled={orderAlreadyCreated}
            />
          </div>
        )}
      </div>
      {step !== 3 && (
        <>
          <div className="complete-order">
            {step === 2 && (
              <button type="button" className="btn-back" onClick={() => onChangeStep(step - 1)}>
                {t('back')}
              </button>
            )}
            <button type="button" className="btn btn-dynamic" onClick={() => onChangeStep(step + 1)}>
              {t('next')}
            </button>
          </div>
        </>
      )}
      {step === 3 && (
        <>
          <CheckoutTerms tenant={tenant} checked={checkedTerms} onChange={onChangeTerms} />
          <div className="complete-order">
            <button type="button" className="btn-back" onClick={() => onChangeStep(step - 1)}>
              {t('back')}
            </button>
            <button type="submit" disabled={isDisabled} className="btn btn-dynamic" onClick={createOrder}>
              {t('checkout.complete.order')}
            </button>
          </div>
        </>
      )}
    </>
  );

AcademySideBar.propTypes = {
  t: PropTypes.func.isRequired,
  onClearCoupon: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  checkoutDetail: PropTypes.shape({
    isPaidWithCoins: PropTypes.bool,
  }).isRequired,
  createOrder: PropTypes.func.isRequired,
  onChangeNotes: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  orderAlreadyCreated: PropTypes.string,
  tenant: PropTypes.shape(TenantProp.propType).isRequired,
  onChangeTerms: PropTypes.func.isRequired,
  checkedTerms: PropTypes.bool.isRequired,
  isDirectSellingActive: PropTypes.bool.isRequired,
  onChangeStep: PropTypes.func.isRequired,
  step: PropTypes.number.isRequired,
};
AcademySideBar.defaultProps = {
  orderAlreadyCreated: null,
};

export default translate(AcademySideBar);
